// AGNT-335: Strip internal tool metadata that should never be shown to users.
// Defense-in-depth — the backend SSE serializer and DB persistence also strip these patterns.

// Matches: **Tool: analyze_pid_connectivity** or **Tool: search_equipment** (from 'Graph Name')
const TOOL_NAME_RE = /\*\*Tool:\s*\w+\*\*\s*(?:\(from\s*'[^']*'\)\s*)?/g
// Matches: **[Inferred]** _based on undirected graph traversal_
// Uses non-greedy .*? to handle underscores in annotation text
const TRUST_LABEL_RE = /\*\*\[(Inferred|Exact|Evidence)\]\*\*\s*(?:_.*?_\s*)?/g

export function stripInternalMetadata(content: string): string {
  return content.replace(TOOL_NAME_RE, '').replace(TRUST_LABEL_RE, '')
}
